import { lazy } from "react";
export const MainPage = lazy(() => import("./MainPage/MainPage"));
export const Leaderboard =lazy(()=>import("./Leaderboard/Leaderboard"))